import React, { useContext, useEffect, useState } from 'react';
import { Link, useLoaderData, useLocation } from "react-router-dom";
import { MyContext } from './MyContext';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import VidyaUpasna from "../assets/VidyaUpasna.jpg";

const SectionSidebar = () => {
  const [open, setOpen] = useState(0);
  // const [teachingOpen, setTeachingOpen] = useState(false);
  const { sidebarToggle } = useContext(MyContext);
  const { pathname } = useLocation()
  // const [examType, setExamType] = useState()
  const authorizedAxios = generateAxiosInstance();
  let instituteMasterId = localStorage.getItem("instituteMasterId");


  useEffect(() => {
    document.title = 'Vidya Upasna (section)';
  }, []);

  // useEffect(() => {
  //   const apiUrl3 = `/get-exam-master`;
  //   authorizedAxios && authorizedAxios.get(apiUrl3)
  //     .then(response => {
  //       setExamType(response.data.result)
  //     })
  //     .catch(error => {
  //       const errorMsg = error?.response?.data?.message || 'Something went wrong!';
  //     });
  // }, [])

  return (
    <div className={sidebarToggle ? "sidebar sidebar-dark sidebar-fixed hide" : "sidebar sidebar-dark sidebar-fixed"} id="sidebar">
      <div className='logo'> <img src={VidyaUpasna} /></div>

      <ul className="sidebar-nav" data-coreui="navigation" data-simplebar="">
        <li className="nav-item "><Link to={'/section-dashboard'} onClick={() => setOpen(0)} className={pathname == '/section-dashboard' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-gauge"></i> Dashboard </Link>
        </li>

        <li className="nav-item "><Link to={'/section-mapped-academic-year'} onClick={() => setOpen(0)} className={pathname == '/section-mapped-academic-year' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-gauge"></i> Mapped Academic Year </Link>
        </li>

        <li className="nav-item "><Link to={'/section-syllabus-structure'} onClick={() => setOpen(0)} className={pathname == '/section-syllabus-structure' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-sitemap"></i> Syllabus Structure </Link>
        </li>

        <li className="nav-item "><Link to={'/section-announcements'} onClick={() => setOpen(0)} className={pathname == '/section-announcements' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-bullhorn"></i> Announcements</Link>
        </li>

        <li className="nav-item "><Link to={'/section-upload-pdf'} onClick={() => setOpen(0)} className={pathname == '/section-upload-pdf' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-file-pdf"></i> Upload PDF Book </Link>
        </li>

        <li className="nav-item "><Link to={'/section-upload-refrence-book'} onClick={() => setOpen(0)} className={pathname == '/section-upload-refrence-book' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-upload"></i> Upload Reference Book </Link>
        </li>

        <li className={`nav-group ${open == 2 ? 'show' : ''}`}><span className="nav-link nav-group-toggle" href="" onClick={() => setOpen((open) => open != 2 ? 2 : 0)}>
          <i class="fa fa-pen-nib"></i> Upload Content </span>
          <ul className="nav-group-items">
            <li className="nav-item"><Link to={'/section-lesson'} className={pathname == '/section-lesson' ? "nav-link active" : "nav-link"} href=""><span className="nav-icon"></span><i class="fa-solid fa-file-circle-check"></i> Lesson</Link></li>
            <li className="nav-item"><Link to={'/section-topic'} className={pathname == '/section-topic' ? "nav-link active" : "nav-link"} href=""><span className="nav-icon"></span><i class="fa-solid fa-hashtag"></i> Topic</Link></li>
            <li className="nav-item"><Link to={'/section-sub-topic'} className={pathname == '/section-sub-topic' ? "nav-link active" : "nav-link"} href=""><span className="nav-icon"></span><i class="fa-solid fa-info"></i> &nbsp; Sub Topic</Link></li>
            <li className="nav-item"><Link to={'/section-video-upload'} className={pathname == '/section-video-upload' ? "nav-link active" : "nav-link"} href=""><span className="nav-icon"></span><i class="fa fa-upload"></i> Upload Video</Link></li>
          </ul>
        </li>

        <li className={`nav-group ${open == 7 ? 'show' : ''}`}><span className="nav-link nav-group-toggle" href="" onClick={() => setOpen((open) => open != 7 ? 7 : 0)}>
          <i class="fas fa-chalkboard-teacher"></i>Teacher</span>
          <ul className="nav-group-items">
            <li className="nav-item "><Link to={'/section-teacher-credentials'} className={pathname == '/section-teacher-credentials' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-key"></i>Teacher Credentials</Link>
            </li>

            <li className="nav-item "><Link to={'/section-teacher-section'} className={pathname == '/section-teacher-section' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-person-chalkboard"></i> Teacher Master </Link>
            </li>

            <li className="nav-item "><Link to={'/section-teacher-mapping'} className={pathname == '/section-teacher-mapping' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-arrow-right-arrow-left"></i> Teacher Mapping </Link>
            </li>

            <li className="nav-item "><Link to={'/section-teaching-plan'} className={pathname == '/section-teaching-plan' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-school"></i> Teaching Plan </Link>
            </li>

            <li className="nav-item "><Link to={'/section-teacher-performance'} className={pathname == '/section-teacher-performance' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-chart-line"></i> Teacher Performance</Link>
            </li>

            <li className="nav-item "><Link to={'/teacher-exam'} className={pathname == '/teacher-exam' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-chalkboard-teacher"></i>For Teacher's Exam</Link>
            </li>

            <li className="nav-item "><Link to={'/section-teacher-uploaded-video'} className={pathname == '/section-teacher-uploaded-video' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-chart-line"></i> Teacher Uploaded Video</Link>
            </li>
          </ul>
        </li>

        <li className={`nav-group ${open == 1 ? 'show' : ''}`}><span className="nav-link nav-group-toggle" href="" onClick={() => setOpen((open) => open != 1 ? 1 : 0)}>
          <i class="fa-solid fa-user"></i>Student</span>
          <ul className="nav-group-items">

            <li className="nav-item "><Link to={'/section-import-student'} className={pathname == '/section-import-student' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-user-plus"></i> Import Student </Link>
            </li>
            <li className="nav-item "><Link to={'/non-approved-student'} className={pathname == '/non-approved-student' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-user-minus"></i> Not Approved Student </Link>
            </li>
            <li className="nav-item "><Link to={'/section-all-student-list'} className={pathname == '/section-all-student-list' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-users-line"></i> All Student </Link>
            </li>
            <li className="nav-item "><Link to={'/section-update-student-division'} className={pathname == '/section-update-student-division' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen-nib"></i> Update Division </Link>
            </li>
            <li className="nav-item "><Link to={'/add-student'} className={pathname == '/add-student' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-user-plus"></i> Add Student </Link>
            </li>

            <li className="nav-item "><Link to={'/student-report'} className={pathname == '/student-report' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Student Report </Link>
            </li>

            <li className="nav-item "><Link to={'/section-student-credentials'} className={pathname == '/section-student-credentials' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-key"></i> Student Credentials </Link>
            </li>

            <li className="nav-item "><Link to={'/section-student-activity'} className={pathname == '/section-student-activity' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-book-reader"></i> Student Activity </Link>
            </li>

            <li className="nav-item "><Link to={'/section-student-attendance'} className={pathname == '/section-student-attendance' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-user-check"></i> Student Attendance </Link>
            </li>

          </ul>
        </li>

        <li className={`nav-group ${open == 10 ? 'show' : ''}`}><span className="nav-link nav-group-toggle" href="" onClick={() => setOpen((open) => open != 10 ? 10 : 0)}>
          <i class="fas fa-comments"></i>DSS</span>
          <ul className="nav-group-items">

            <li className="nav-item "><Link to={'/section-teacher-dss-report'} className={pathname == '/section-teacher-dss-report' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-chart-bar"></i>Teacher</Link>
            </li>
            <li className="nav-item "><Link to={'/section-teacher-dss-chat-history'} className={pathname == '/section-teacher-dss-chat-history' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-chart-bar"></i>Teacher Chat History</Link>
            </li>
            <li className="nav-item "><Link to={'/section-subject-dss-report'} className={pathname == '/section-subject-dss-report' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-book-open"></i>Subject</Link>
            </li>
            {instituteMasterId == process.env.REACT_APP_REGISTER_INSTITUTE_ID &&
              <li className="nav-item "><Link to={'/section-dss-report-complain'} className={pathname == '/section-dss-report-complain' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
                <i class="fas fa-book-open"></i>Dss Complain</Link>
              </li>}

          </ul>
        </li>

        <li className={`nav-group ${open == 6 ? 'show' : ''}`}><span className="nav-link nav-group-toggle" href="" onClick={() => setOpen((open) => open != 6 ? 6 : 0)}>
          <i class="fa-solid fa-calendar-week"></i>Daily Overview</span>
          <ul className="nav-group-items">
            <li className="nav-item "><Link to={'/section-daily-presenty'} className={pathname == '/section-daily-presenty' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-user-check"></i> Daily Presenty </Link>
            </li>

            <li className="nav-item "><Link to={'/section-daily-schedule'} className={pathname == '/section-daily-schedule' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-tasks"></i> Daily Schedule </Link>
            </li>
          </ul>
        </li>

        <li className={`nav-group ${open == 3 || open == 4 || open == 5 ? 'show' : ''}`}><span className="nav-link nav-group-toggle" href="" onClick={() => setOpen((open) => open != 3 ? 3 : 0)}>
          <i class="fa fa-pen-nib"></i> Question Bank </span>
          <ul className="nav-group-items">
            <li className={`nav-group ${open == 4 ? 'show' : ''}`}>
              <span className="nav-link nav-group-toggle" href="" onClick={() => setOpen((open) => open != 4 ? 4 : 3)}>
                <i class="fa fa-pen-nib"></i> Text Book </span>
              <ul className="nav-group-items text-group-item">
                <li className="nav-item"><Link to={'/section-upload-text-book'} className={pathname == '/section-upload-text-book' ? "nav-link active" : "nav-link"} href=""><span className="nav-icon"></span><i class="fa-solid fa-file-circle-check"></i>
                  Upload
                </Link></li>
                <li className="nav-item"><Link to={'/section-update-text-book'} className={pathname == '/section-update-text-book' ? "nav-link active" : "nav-link"} href=""><span className="nav-icon"></span><i class="fa fa-eye"></i> Update</Link></li>
                <li className="nav-item"><Link to={'/section-view-text-book'} className={pathname == '/section-view-text-book' ? "nav-link active" : "nav-link"} href=""><span className="nav-icon"></span><i class="fa fa-eye"></i> View</Link></li>
              </ul>
            </li>
          </ul>
        </li>

        <li className="nav-item " onClick={() => setOpen(0)}><Link to={'/section-view-content-book'} className={pathname == '/section-view-content-book' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-eye"></i> View Content Book </Link>
        </li>

        <li className="nav-item " onClick={() => setOpen(0)}><Link to={'/section-video-content-upload'} className={pathname == '/section-video-content-upload' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa-solid fa-cloud-arrow-up"></i> Video Content Upload </Link>
        </li>

        <li className="nav-item " onClick={() => setOpen(0)}><Link to={'/section-study-material-show'} className={pathname == '/section-study-material-show' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-book"></i>Study Material Show</Link>
        </li>

        <li className="nav-item " onClick={() => setOpen(0)}><Link to={'/section-tag-master'} className={pathname == '/section-tag-master' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa-solid fa-tag"></i> Tag Master </Link>
        </li>

        <li className="nav-item " onClick={() => setOpen(0)}><Link to={'/section-export-student-details'} className={pathname == '/section-export-student-details' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-file"></i> Export Sudent Details </Link>
        </li>

        <li className={`nav-group ${open == 8 ? 'show' : ''}`}><span className="nav-link nav-group-toggle" href="" onClick={() => setOpen((open) => open != 8 ? 8 : 0)}>
          <i class="fa-solid fa-file-video"></i> Exam </span>
          <ul className="nav-group-items">
            {/* <li className="nav-item "><Link to={'/exam-create'} className={pathname == '/exam-create' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-list"></i> Exam Create </Link>
            </li>
            <li className="nav-item "><Link to={'/upload-exam'} className={pathname == '/upload-exam' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Upload Exam </Link>
            </li> */}

            <li className="nav-item "><Link to={'/test-copier'} className={pathname == '/test-copier' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-list"></i> Test Copier </Link>
            </li>

            <li className="nav-item "><Link to={'/create-exam'} className={pathname == '/create-exam' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-list"></i> Exam Create </Link>
            </li>
            <li className="nav-item "><Link to={'/exam-upload'} className={pathname == '/exam-upload' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Upload Exam </Link>
            </li>

            <li className="nav-item "><Link to={'/upload-pdf-exam'} className={pathname == '/upload-pdf-exam' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Upload Pdf Exam </Link>
            </li>
            <li className="nav-item "><Link to={'/student-random-exam'} className={pathname == '/student-random-exam' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Random Exam </Link>
            </li>
            <li className="nav-item "><Link to={'/create-exam-paper'} className={pathname == '/create-exam-paper' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-file-alt"></i> Create Exam Paper</Link>
            </li>
            <li className="nav-item "><Link to={'/generate-exam-paper'} className={pathname == '/generate-exam-paper' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-folder-open"></i> Generate Exam Paper</Link>
            </li>
            <li className="nav-item "><Link to={'/assign-exam'} className={pathname == '/assign-exam' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Assign Exam </Link>
            </li>
            <li className="nav-item "><Link to={'/exam-details'} className={pathname == '/exam-details' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Exam Details </Link>
            </li>
            <li className="nav-item "><Link to={'/teacher-hosted-exam-details'} className={pathname == '/teacher-hosted-exam-details' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa fa-chalkboard-teacher"></i>Teacher Hosted Exam</Link>
            </li>
            <li className="nav-item "><Link to={'/section-exam-request'} className={pathname == '/section-exam-request' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fas fa-user-clock"></i> Exam Request </Link>
            </li>
            <li className="nav-item "><Link to={'/section-exam-download-request'} className={pathname == '/section-exam-download-request' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa fa-download"></i> Exam Download Request </Link>
            </li>
          </ul>
        </li>

        <li className="nav-item " onClick={() => setOpen(0)}><Link to={'/teacher-exam-view'} className={pathname == '/teacher-exam-view' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-eye"></i>Teacher Exam View</Link>
        </li>

        <li className={`nav-group ${open == 9 ? 'show' : ''}`}><span className="nav-link nav-group-toggle" href="" onClick={() => setOpen((open) => open != 9 ? 9 : 0)}>
          <i class="fas fa-file-alt"></i> Exam Report </span>
          <ul className="nav-group-items">
            <li className="nav-item "><Link to={`/section-exam-report-by-division`} className={pathname == '/section-exam-report-by-division' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Report By Division </Link>
            </li>
            <li className="nav-item "><Link to={`/section-exam-report-by-exam-type`} className={pathname == '/section-exam-report-by-exam-type' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Report By Exam Type </Link>
            </li>
            <li className="nav-item "><Link to={`/section-exam-report-by-subject`} className={pathname == '/section-exam-report-by-subject' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Report By Subject </Link>
            </li>
            <li className="nav-item "><Link to={`/section-exam-report-by-teacher`} className={pathname == '/section-exam-report-by-teacher' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Report By Teacher </Link>
            </li>
            <li className="nav-item "><Link to={`/section-exam-download-report`} className={pathname == '/section-exam-download-report' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
              <i class="fa-solid fa-pen"></i> Exam Download Report </Link>
            </li>
          </ul>
        </li>

        <li className="nav-item " onClick={() => setOpen(0)}><Link to={'/list-of-assigned-exam'} className={pathname == '/list-of-assigned-exam' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa-solid fa-chalkboard-user"></i> List of Assigned Exam </Link>
        </li>


        {/* <li className="nav-item " onClick={() => setOpen(0)}><Link to={'/create-exam'} className={pathname == '/create-exam' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa-solid fa-chalkboard-user"></i>Create Exam</Link>
        </li>

        <li className="nav-item " onClick={() => setOpen(0)}><Link to={'/exam-upload'} className={pathname == '/exam-upload' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa-solid fa-chalkboard-user"></i>Exam Upload</Link>
        </li> */}

        <li className="nav-item" onClick={() => setOpen(0)}><Link to={'/section-search-master'} className={pathname == '/section-search-master' ? "nav-link active" : "nav-link"} href="https://coreui.io/docs/templates/installation/">
          <i class="fa fa-search"></i>Search Content </Link>
        </li>

      </ul>
    </div>
  )
};

export default SectionSidebar;